'use strict';

import {Warning} from 'ais-common';

export class PredmetPonuka
{
    id: number;
    idPredmetRok: number;
    idZapisnyList: number;
    skratka: string;
    skratkaFull: string;
    nazov: string;
    kredit: number;
    semester: string;
    semesterSk: string;
    rozsah: string;
    rozsahASposobPopis: string;
    jazyk: string[];
    search: string;
    ukoncenie: string;
    cast: string;

    warnings: Warning[] = [];

    addWarning(w: any): this
    {
        const warning = new Warning();
        warning.code = w.code;
        warning.message = w.message;
        warning.umss = w.umss;
        warning.messageOrigin = w.messageOrigin;
        this.warnings.push(warning);
        return this;
    }

}
